import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Carte de crédit',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Payer par virement',
    [PaymentMethod.SepaDebit]: 'Carte EC / IBAN',
    [PaymentMethod.Cash]: 'Espèces',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Autre mode de paiement',
  },
};
